import React from 'react';

/**
 * Static SVG stand-in for the "Text" block on its palette card: a paragraph of
 * prose with no heading. Wireframe style, matching {@link TextSectionPreviewGraphic}.
 */

const CARD_X = 30;
const CARD_Y = 30;
const CARD_W = 1120;
const PAD = 28;
const INNER_W = CARD_W - PAD * 2;
const BAR_H = 14;
const BAR_STEP = 30;
const ROWS = [1, 1, 1, 0.62];
const CARD_H = PAD * 2 + (ROWS.length - 1) * BAR_STEP + BAR_H;
const VIEW_H = CARD_Y + CARD_H + 16;

export default function TextPreviewGraphic() {
  return (
    <svg
      viewBox={`0 0 1180 ${VIEW_H}`}
      width="100%"
      role="img"
      aria-label="Text block: a paragraph with no heading"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <rect
        x={CARD_X}
        y={CARD_Y}
        width={CARD_W}
        height={CARD_H}
        rx="20"
        fill="#F1F2EF"
        stroke="#E4E4E0"
      />
      {ROWS.map((ratio, index) => (
        <rect
          key={index}
          x={CARD_X + PAD}
          y={CARD_Y + PAD + index * BAR_STEP}
          width={INNER_W * ratio}
          height={BAR_H}
          rx={BAR_H / 2}
          fill={ratio < 1 ? '#D8DBDE' : '#C7CBD0'}
        />
      ))}
    </svg>
  );
}
